import { render, staticRenderFns } from "./flight-pad-stops.vue?vue&type=template&id=13a37e52&scoped=true"
import script from "./flight-pad-stops.vue?vue&type=script&lang=js"
export * from "./flight-pad-stops.vue?vue&type=script&lang=js"
import style0 from "./flight-pad-stops.vue?vue&type=style&index=0&id=13a37e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a37e52",
  null
  
)

export default component.exports